import { NotificationFilterOption } from '@/constants/notificationFilters';

export interface ResidentFilters {
  categories: string[];
  residentId: number | null;
  notificationTypes: string[];
}

export const matchesNotificationFilter = (
  notificationType: string,
  selectedValues: string[],
  options: NotificationFilterOption[],
) => !selectedValues.length || options.some((option) =>
  selectedValues.includes(option.value) && option.notificationTypes.includes(notificationType),
);
